document.addEventListener('DOMContentLoaded', () => {
    const focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    function getFocusableElements(container) {
        return Array.from(container.querySelectorAll(focusableSelectors))
        .filter(el => !el.disabled && el.offsetParent !== null);
    }

    function openModal(modalId, triggerEl) {
        const modal = document.getElementById(modalId);
        if (!modal) return;

        document.querySelector("body").classList.add("ns-form-layout-no-overflow");
        modal.classList.add("active");
        modal.dataset.active = "true";
        modal.dataset.trigger = triggerEl.id || "";
        modal._lastFocused = document.activeElement;

        const focusableEls = getFocusableElements(modal);
        modal._focusableEls = focusableEls;
        modal._first = focusableEls[0];
        modal._last = focusableEls[focusableEls.length - 1];

        (modal._first || modal).focus();
    }

    function closeModal(modal) {
        document.querySelector("body").classList.remove("ns-form-layout-no-overflow");
        modal.classList.remove("active");
        modal.dataset.active = "false";

        if (modal._lastFocused && typeof modal._lastFocused.focus === "function") {
            modal._lastFocused.focus();
        }

        modal._focusableEls = null;
        modal._first = null;
        modal._last = null;
    }

    document.querySelectorAll('[data-modal-trigger]').forEach(trigger => {
        trigger.addEventListener('click', e => {
            e.preventDefault();
            openModal(trigger.dataset.modalTrigger, trigger);
        });

        trigger.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                openModal(trigger.dataset.modalTrigger, trigger);
            }
        });
    });

    document.querySelectorAll('[data-modal-close]').forEach(btn => {
        btn.addEventListener('click', () => {
            const modal = btn.closest('[role="dialog"]');
            closeModal(modal);
        });
    });

    document.addEventListener('keydown', e => {
        const modal = document.querySelector('#nsModalFormPopup[role="dialog"][data-active="true"]');
        if (!modal) return;

        if (e.key === 'Escape') {
            closeModal(modal);
            return;
        }

        if (e.key === 'Tab') {
            const focusable = modal._focusableEls || getFocusableElements(modal);
            if (focusable.length === 0) return;
            const first = modal._first || focusable[0];
            const last = modal._last || focusable[focusable.length - 1];
            if (e.shiftKey) {
                if (document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        }
    });
});
